import { Routes, Route } from 'react-router-dom';

import routes from '../config/routesConfig';
import { ROUTE_TYPES } from '../config/constants';
import NoRemoteRouteMatched from './NoMatchingRoute';
import { renderRoutes } from '../helpers';
const ShareableRoutes = () => (
  <Routes>
    {renderRoutes(routes, ROUTE_TYPES.shareableRoutes)}
    <Route element={<NoRemoteRouteMatched />} />
  </Routes>
);

export default ShareableRoutes;
